import { httpClient } from '../api/http-client';
import { API_ENDPOINTS } from '../../constants/api';

export interface DashboardStats {
  kpis: {
    totalUsuarios: number;
    totalMiembros: number;
    totalMinisterios: number;
    totalEventos: number;
    eventosEsteMes: number;
    miembrosNuevosEsteMes: number;
  };
  miembros: {
    porGenero: { nombre: string; valor: number; color: string }[];
    porEstadoCivil: { nombre: string; valor: number }[];
    porRangoEdad: { nombre: string; valor: number }[];
    registrosPorMes: { mes: string; cantidad: number }[];
    topZonas: { zona: string; cantidad: number }[];
  };
  eventos: {
    porEstado: { nombre: string; valor: number; color: string }[];
    proximosEventos: {
      id: string;
      titulo: string;
      fecha: string;
      lugar?: string;
      estado: string;
    }[];
    eventosPorMes: { mes: string; cantidad: number }[];
  };
  usuarios: {
    porTipo: { nombre: string; valor: number; color: string }[];
    porEstado: { nombre: string; valor: number }[];
  };
  ministerios: {
    activos: number;
    inactivos: number;
    conLider: number;
    sinLider: number;
    topMinisterios: { nombre: string; integrantes: number }[];
    registrosPorMinisterio: { id: string; nombre: string; registrados: number }[];
  };
  espiritual: {
    bautizados: number;
    noBautizados: number;
    oracionFe: number;
    pertenecenMinisterio: number;
  };
}

class DashboardServiceClass {
  async getStats(): Promise<DashboardStats> {
    const response = await httpClient.get<
      DashboardStats | { data: DashboardStats; statusCode: number; timestamp: string }
    >(API_ENDPOINTS.dashboard.stats);

    const payload = response.data;

    // El backend envuelve respuestas en { data, statusCode, timestamp }
    if (payload && 'data' in payload && 'statusCode' in payload) {
      return (payload as any).data;
    }

    return payload as DashboardStats;
  }
}

export const DashboardService = new DashboardServiceClass();
